import {createStore} from 'vuex'
import {useToast} from 'vue-toastification'
import {isPlainObject} from "@/utils/helpers";

import moduleCatalog from "@/store/modules/moduleCatalog";
import moduleWebForm from "@/store/modules/moduleWebForm";
import moduleCart from "@/store/modules/moduleCart";
import moduleIndividualPacking from "@/store/modules/moduleIndividualPacking";

const toast = useToast();
export default createStore({
    state() {
        return {
            loadingPool: new Set(),
        }
    },
    mutations: {
        startLoading(state, name) {
            state.loadingPool.add(name)
            if (!state.isLoading) state.isLoading = true
        },
        stopLoading(state, name) {
            if (state.loadingPool.has(name)) {
                state.loadingPool.delete(name)
            } else {
                console.error(`${name} : не найдено в пуле загрузки`)
            }
            if (!state.loadingPool.size) {
                state.isLoading = false
            }
        },
    },
    actions: {
        errorMessage (context, {message}) {
            if (!message) return;
            if (message === 'SyntaxError: Unexpected end of JSON input') {
                message = 'unexpected error';
            }
            toast.error(message);
        },
        showError(context, { error }) {
            let message

            if (isPlainObject(error) || error instanceof Error) {

                if (error.request?.status === 403) {
                    window.location.href = window.location.origin;
                }

                message = error.response?.data?.error?.message || error.message;
            }

            if (typeof error === 'string') {
                message = error
            }

            toast.error(message);

            return message;
        },
    },
    getters: {
        isLoading: state => state.isLoading,
        isRequestPending: state => requestName => state.loadingPool.has(requestName),
    },
    modules: {
        moduleCatalog,
        moduleWebForm,
        moduleCart,
        moduleIndividualPacking
    }
})